var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1960 4065 l0 -1055 600 0 600 0 0 1055 0 1055 -600 0 -600 0 0 -1055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3610 2860 l0 -1350 600 0 600 0 0 1350 0 1350 -600 0 -600 0 0 -1350z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 2560 l0 -450 600 0 600 0 0 450 0 450 -600 0 -600 0 0 -450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 1505 l0 -1205 -225 0 -225 0 0 755 0 755 -600 0 -600 0 0 -755 0 -755 -155 0 -155 0 0 -150 0 -150 2560 0 2560 0 0 150 0 150 -155 0 -155 0 0 455 0 455 -600 0 -600 0 0 -455 0 -455 -225 0 -225 0 0 1205 0 1205 -600 0 -600 0 0 -1205z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.f31cdee773f74460b464fa135932ea46.svg";
export { ForwardRef as ReactComponent };